import { DELETE_SHIFT_BLOCK } from 'constants/endpoints';
import { METHOD_DELETE } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_DELETE_shiftBlock = (blockId: string): ApiRequestConfigType => {
  return {
    __typename: 'LegacyAPI',
    url: DELETE_SHIFT_BLOCK(blockId),
    method: METHOD_DELETE,
  };
};
